<template>
    <section class="counter-sec">

        <div class="container small-sec">

            <div class="row">
                <div v-for="counter in counter_list" v-bind:key="counter.id" class="col-md-3">
                    <div class="circle-col">
                        <div class="circle-box">
                            <div class="circle" :id="counter.circleId"></div>
                            <template>
                                <radial-progress-bar :diameter="120" startColor="#0abadd" stopColor="#0abadd"
                                    innerStrokeColor="#fdfdfd" :completed-steps="counter.value"
                                    :total-steps="counter.maxValue">

                                    <div class="circles-text">
                                        {{ numeral(counter.value).format('0,0').replace(' ', '.') }}
                                    </div>
                                </radial-progress-bar>
                            </template>
                        </div>
                        <div class="circle-box-text">
                            {{ counter.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-lin-sec-2">
            <div class="container small-sec">
                <div class="text-lin__text-bg">
                    Правно-информациони систем Републике Србије успостављен је Законом о објављивању закона и других
                    прописа и аката („Службени гласник РС“, број 45/2013), од 1. јануара 2014. године, као збирка
                    података у електронском облику. Вођење Правно-информационог система РС, као делатности од општег
                    интереса, поверено је ЈП Службени гласник.

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress';
import axios from 'axios';
import numeral from 'numeral';


export default {
    name: "HomeCounterSec",
    data() {
        return {

            numeral: numeral,

            statisticsUrl:window.env.VUE_APP_API_FP_DEV + 'prins/GetDocTypeHtml?uuid=40b4c407-096e-454c-814e-4abbd7e485dc&id=19&doctype=fpstaticpage',

            counter_list: [
                {
                    id: 1,
                    circleId: 'circles-1',
                    title: "Укупан број закона објављених у текућој години",
                    re: /у текућој години објављено је:<\/p>[^/]+>([0-9]+)<\/span> закона/,
                    value: 0,
                    maxValue: 150
                },
                {
                    id: 2,
                    circleId: 'circles-2',
                    title: "Укупан број уредби објављених у текућој години",
                    re: /у текућој години објављено је:<\/p>[^/]+>([0-9]+)<\/span> уредби/,
                    value: 0,
                    maxValue: 300
                },
                {
                    id: 3,
                    circleId: 'circles-3',
                    title: "Укупан број аката објављених у бази Регистар",
                    re: /Укупан број аката у бази која садржи база Регистар[^/0-9]+([0-9]+)/,
                    value: 0,
                    maxValue: 20000
                },
                {
                    id: 4,
                    circleId: 'circles-4',
                    title: "Укупан број гласила у Архиви службених гласила",
                    re: /Гласникова архива службених гласила садржи[^/0-9]+([0-9]+)/,
                    value: 0,
                    maxValue: 15000
                },
            ]
        }
    },
    mounted: function () {
        console.log("R", this.statisticsUrl);
        // http://10.10.30.99:8080/prins/GetDocTypeHtml?uuid=40b4c407-096e-454c-814e-4abbd7e485dc&staticpageid=19&doctype=fpstaticpage
        axios.get(this.statisticsUrl)
            .then(response => {
                for (var i = 0; i < this.counter_list.length; i++) {
                    var item = this.counter_list[i];
                    // Vađenje vrednosti regularnim izrazima iz raw HTML-a.
                    var match = response.data.match(item.re);
                    item.value = parseInt(match[1]);
                }
            })
    },
    components: {
        RadialProgressBar
    }
}
</script>

<style scoped></style>
